var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.854.146a.5.5 0 10-.708.708L11.293 4H.5a.5.5 0 000 1h10.793L8.146 8.146a.5.5 0 10.708.708l4-4A.499.499 0 0013 4.5m-.038-.191a.5.5 0 00-.108-.163l-4-4m4.108 4.163a.5.5 0 01.038.188z","fill":"#fff"}));
}

Arrow.defaultProps = {"fill":"none","viewBox":"0 0 13 9"};

module.exports = Arrow;

Arrow.default = Arrow;
